<template>
  <div class="ai-assistent-chat">
    <div class="msg-chat-item" v-for="(item, index) in chatMsgListShow" :key="index">
      <!-- 左侧 -->
      <div class="msg-chat-item-left">
        <!-- icon -->
        <img src="@/assets/img/robot.gif" class="left-icon-robot" width="25px" height="25px"
          v-if="item.type === chat_show_type_sys" />
        <span v-else class="left-icon-user">
          <i class="icon iconfont icon-geren9"></i>
        </span>
      </div>
      <!-- 内容 -->
      <div class="msg-chat-item-right">
        <div class="chat-item-outer" :class="[item.status === content_status_loading && 'loading']">
          <!-- loading 状态 -->
          <AiAssistentLoading v-if="item.status === content_status_loading" :statusText="item.statusText">
          </AiAssistentLoading>
          <div v-else>
            <Markdown :source="item.content" :options="{ gfm: true }"></Markdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AiAssistentLoading from './aiAssistentLoading.vue'
import Markdown from 'vue-markdown';
import bus from '@/utils/eventBus.js';
export default {
  name: 'AiAssistentChat',
  components: { AiAssistentLoading, Markdown },
  props: {
    chatOriginalList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chat_show_type_sys: '1',
      content_status_loading: '0',
      chatMsgListShow: [], // 展示列表
    }
  },
  watch: {
    'chatOriginalList': {
      handler(newList) {
        this.setChatMsgList(newList)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 处理展示列表
    async setChatMsgList(list) {
      list = JSON.parse(JSON.stringify(list || []))

      // 数据展示处理
      for (let i = 0; i < list.length; i++) {
        const uuid = list[i].id
        const type = list[i].type // 1:返回，2：用户输入
        const index = this.chatMsgListShow.findIndex(item => item.id === uuid)
        if (index === -1) {
          // 添加新的
          if (type === this.chat_show_type_sys) {
            // 系统返回
            if (list[i].showBtns) {
              // 带按钮，不能流式
              this.chatMsgListShow.push(list[i])
            } else {
              if (list[i].isNoWater) {
                this.chatMsgListShow.push(list[i])
              } else {
                // 流式
                await this.waterStreamShow(list[i], i)
              }
            }
          } else {
            // 用户输入
            this.chatMsgListShow.push(list[i])
          }

        } else {
          // 修改旧的,类型、按钮展示
          if (type === this.chat_show_type_sys) {
            // 系统返回
            if (i < list.length - 1) {
              this.chatMsgListShow.splice(i, 1, list[i])
            } else {
              // 处理最后一条数据，前端loading，和后台接口loading
              // 处理 loading，展示接口返回的数据
              this.chatMsgListShow.pop()
              if (list[i].isNoWater) {
                this.chatMsgListShow.splice(i, 1, list[i])
              } else {
                await this.waterStreamShow(list[i], i)
              }
            }
          } else {
            // 用户输入
            this.chatMsgListShow.splice(i, 1, list[i])
          }
        }
      }

      bus.$emit('scrollToBottom')
    },
    // 流式 展示
    waterStreamShow(item, index) {
      let _this = this
      return new Promise((resolve) => {
        const content = item.content || ''
        const itemFirst = {
          ...item,
          content: ''
        }

        this.chatMsgListShow.push(itemFirst)

        const target = this.chatMsgListShow[index]

        const contentArr = content.split('<br />')
        const hasBr = content.indexOf('<br />') !== -1

        let i = 0,
          j = 0;

        function delayShow(target, arrStr) {
          // 判断标签
          let isSpecial = _this.judgeSpecialLabels(arrStr[i])
          if (isSpecial) {
            target.content += arrStr[i]
            j = arrStr[i].length - 1
          } else {
            target.content += arrStr[i][j]
          }
          if (j === arrStr[i].length - 1) {
            if (hasBr && (i < arrStr.length - 1)) {
              target.content += '<br />'
            }
            i++
            j = 0
          }
          j++
          if (i < arrStr.length) {
            setTimeout(() => {
              delayShow(target, arrStr)
            }, 30)
          } else {
            resolve()
          }
        }
        delayShow(target, contentArr)
      })
    },
    // 判断是否有标签
    judgeSpecialLabels(text) {
      const labels = ['</span>']
      return labels.some(item => text.indexOf(item) !== -1)
    },
  }
}
</script>
<style lang="scss" scoped>
.ai-assistent-chat {
  .msg-chat-item+.msg-chat-item {
    margin-top: 12px;
  }

  .msg-chat-item {
    margin-bottom: 8px;
    padding-right: 12px;
    display: flex;



    .msg-chat-item-left {
      .left-icon-user {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 25px;
        height: 25px;

        .icon {
          font-size: 19px;
        }
      }
    }

    .msg-chat-item-right {
      margin-left: 4px;

      .chat-item-outer {
        padding: 4px 6px;
        box-sizing: border-box;
        background: #f4f2f2;
        border-radius: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/aiAssistent/aiAssistentChat.vue